import FieldReaction_Popover from "./components/popover/popover-menu"
import FieldReaction_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldReaction_View from "./render/view"
import FieldReaction_ManagementPreview from "./render/management/management-preview"
import FieldConfig from "../../proto/field-config"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldReaction_ManagementFormCFV1 from "./render/management/management-form-cfv1";
import {SessionCustomField} from "../../../gd-model/custom-field/gd-custom-field";
import {FieldType} from "../../field-type";
import FieldPopover from "../popover/popover";
import CustomFieldsV1 from "../../../gd/const/fields/custom-fields-v1";
import FieldReaction_TableCell from "./render/table/table-cell";
import Reactions from "../../../model2/reaction/reactions";
import FieldTReaction_ViewProperty from "./render/property";

// export default class FieldReaction extends FieldDropdown {
export default class FieldReaction extends FieldPopover {

    FIELD_DEFAULT_WIDTH: number = 160;

    public pillMaxWidth         : number        = 56    // used in table view

    constructor(config:FieldConfig) {
        super(config);

        this.typeInteger        = CustomFieldsV1.type.REACTION
        this.typeLabel          = "Reaction";
        this.filterType         = null; //'color';
        this.typeGroup          = GROUP_MISC
        this.typeDescription    = "Reaction"
        this.icon               = 'i5-smile';

        this.label              = config.label || '' // 'Reaction' // here Reaction word is used as default value for a label when create a new field

        // special
        this.options            = [] //_.get(config, 'options', PROJECT_COLORS);

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',true);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','None');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.isSearchable           = true
        this.isColorCodingAvailable = false


        this.components.PopoverMenu           = FieldReaction_Popover

        // this.components.FormValueEmpty        = FieldColor_FormValueEmpty
        // this.components.FormValueNotEmpty     = FieldColor_FormValueNotEmpty
        //
        // this.components.InlineValueEmpty      = FieldColor_InlineValueEmpty
        this.components.InlineValueNotEmpty   = FieldReaction_InlineValueNotEmpty
        //
        // this.components.PickerValueEmpty      = FieldColor_PickerValueEmpty
        // this.components.PickerValueNotEmpty   = FieldColor_PickerValueNotEmpty
        //
        // this.components.glistGroupModern      = FieldColor_GlistGroupModern
        // this.components.glistGroupStandard    = FieldColor_GlistGroupStandard



        this.renderComponents.view                  = FieldReaction_View
        this.renderComponents.viewSmall             = FieldReaction_View

        this.renderComponents.tableCell             = FieldReaction_TableCell // Not editable because editable is multiline not single line
        this.renderComponents.viewProperty          = FieldTReaction_ViewProperty

        this.renderComponents.managementPreview     = FieldReaction_ManagementPreview
        this.renderComponents.managementFormCFV1    = FieldReaction_ManagementFormCFV1

    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldReaction({
            fieldId         : customFieldV1.id,
            type            : FieldType.REACTION,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }

    // START Value helpers

    toggleValue(model:any, optionValue:any) {

        const reactions : Reactions = Reactions.initFromJson(this.getViewValue(model))

        if (reactions.isMyReaction(optionValue)) {
            return this.removeValue(model, optionValue)
        } else {
            return this.addValue(model, optionValue)
        }
    }

    addValue(model:any, reationType:any) {
        const currentValue : Reactions = Reactions.initFromJson(this.getViewValue(model))
        currentValue.addMyReaction(reationType)
        return currentValue.toJSON()
    }

    removeValue(model:any, optionValue:any) {
        const currentValue : Reactions = Reactions.initFromJson(this.getViewValue(model))
        currentValue.removeMyReaction(optionValue)
        return currentValue.toJSON()
    }

    isEmpty(model:any) {
        const currentValue : Reactions = Reactions.initFromJson(this.getViewValue(model))
        return currentValue.isEmpty
    }

    // END Value helpers



    toJson() {
        let result = super.toJson();

        // we DO NOT want to export options
        delete result.options

        return result;
    }

    // getColorCoding(model: any): ItemColorCoding {
    //     const value = _.get(model, this.fieldId, null)
    //     // const value = gd.session.projects.get(model.id).color
    //
    //     if (!_.isNil(value)) {
    //         return {
    //             colorNumber     : value,
    //             corePalette     : CorePalette.CORE
    //         }
    //     } else {
    //         return super.getColorCoding(model)
    //     }
    // }
}
